<div class="table-header pb-3 px-4">
  <div class="header-content">
    <h2 class="table-title">{{ 'app.devices.dashboard.all_devices_title' | translate }}</h2>
    <button mat-icon-button (click)="facade.reload()"
      class="d-flex align-items-center justify-content-center focus-outline-none"
      [matTooltip]="'shared.general.tooltips.refresh' | translate" [disabled]="facade.isLoading()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
  @if (count() !== null) {
  <div class="count-line">
    <span class="count-badge">{{ count() }}</span>
    <span class="count-label">{{
      'app.devices.dashboard.devices_found_suffix' | translate
      }}</span>
  </div>
  }
</div>
<div class="table-wrapper" #tableWrapper>
  <table mat-table [dataSource]="dataSource()" matSort (matSortChange)="onSortChange($event)">
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.devices.table.columns.index' | translate }}
      </th>
      <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
    </ng-container>

    <ng-container matColumnDef="deviceName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="deviceName">
        {{ 'app.devices.table.columns.device_name' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.displayDeviceName() | translate }}</td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.devices.table.columns.user' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.displayUser() | translate }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.devices.table.columns.user_email' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <app-table-copy-cell [content]="row.displayEmail() | translate"
          [tooltipText]="'app.devices.table.columns.user_email' | translate">
        </app-table-copy-cell>
      </td>
    </ng-container>

    <ng-container matColumnDef="operatingSystem">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.devices.table.columns.operating_system' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.displayOperatingSystem() | translate }}</td>
    </ng-container>

    <ng-container matColumnDef="complianceState">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.devices.table.columns.compliance' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <av-bool-cell [value]="row.displayCompliance()" class="d-flex justify-content-center" />
      </td>
    </ng-container>

    <ng-container matColumnDef="agent">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.devices.table.columns.agent' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <av-bool-cell [matTooltip]="row.agent" [value]="row.agent"></av-bool-cell>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.devices.table.columns.action' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <a [routerLink]="['/devices', row.routeId()]" [style.color]="'var(--avyna-color-primary)'">
          {{ 'app.devices.table.actions.view_details' | translate }}
        </a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  @if (dataSource().data.length === 0) {
  <div class="no-data-content mt-5 pt-5">
    @if (isLoading()) {
    <mat-spinner diameter="40"></mat-spinner>
    <span>{{ 'app.devices.table.loading' | translate }}</span>
    } @else {
    <span>{{ 'app.devices.table.no_data' | translate }}</span>
    }
  </div>
  }

  <app-table-loading-bar [isLoading]="isLoading()"></app-table-loading-bar>
  <div class="bottom-detector" #bottomDetector></div>
</div>

<div class="load-more-container">
  @if (!isLoadingMore()) {
  <button mat-flat-button class="load-more-btn d-flex" [class.visible]="hasMore() && isBottomReached() && !isLoading()"
    (click)="loadMore()" [disabled]="isLoadingMore()">
    <span>{{ 'app.devices.table.load_more' | translate }}</span>
  </button>
  } @else {
  <mat-spinner class="mx-auto" diameter="40" strokeWidth="5"></mat-spinner>
  }
</div>